module.exports = __webpack_public_path__ + "static/img/zf_img_bg02.74a8afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/zf_img_bg02.png
// module id = ThEP
// module chunks = 1